import { Link } from 'react-router-dom'
import { useI18n } from '../../i18n'
import { GovernanceListingSection } from '../../components/governance/GovernanceListingSection'
import {
  DefendSphereAiConversation,
  useDefendSphereAiOptional,
} from '../../components/defendsphere-ai'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

/**
 * Compliance Center AI Conversation page — Phase 5A SSOT via DefendSphereAiProvider.
 * Shares session, messages, and pending outbound approval with the global AI panel/workspace.
 * AI-4: no feature-flag gate — availability is auth + RBAC + provider policy.
 */
export default function GovernanceAiConversationWorkspace() {
  const { t } = useI18n()
  const ai = useDefendSphereAiOptional()

  if (!ai) {
    return (
      <div className={listStyles.pageStack}>
        <GovernanceListingSection
          title={t('complianceCenterUi.nav.aiCiso', 'AI CISO')}
          description={t(
            'complianceCenterUi.defendSphereAi.providerMissing',
            'DefendSphere AI shell is unavailable on this page.',
          )}
        />
      </div>
    )
  }

  if (!ai.enabled) {
    return (
      <div className={listStyles.pageStack}>
        <GovernanceListingSection
          title={t('complianceCenterUi.nav.aiCiso', 'AI CISO')}
          description={t(
            'complianceCenterUi.defendSphereAi.authRequired',
            'Sign in to use DefendSphere AI.',
          )}
        />
      </div>
    )
  }

  return (
    <div className={listStyles.pageStack}>
      <GovernanceListingSection
        title={t('complianceCenterUi.nav.aiCiso', 'AI CISO')}
        description={t(
          'complianceCenterUi.aiCisoIntro',
          'Organization-scoped security, risk and compliance advisor. Ask about risks, vulnerabilities, evidence, controls, suppliers, audit readiness, standards, and recommendations.',
        )}
      >
        <p className="text-xs text-slate-500 m-0 mb-3">
          <Link to="/compliance-center/ai-governance-intelligence" className="text-blue-700 underline">
            {t(
              'complianceCenterUi.backToGovernanceIntelligence',
              '← AI Governance Intelligence (proactive insights)',
            )}
          </Link>
        </p>
      </GovernanceListingSection>

      <div className="ds-ai-page-shell">
        <DefendSphereAiConversation api={ai.conversation} t={t} showHistory />
      </div>
    </div>
  )
}
